import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { Icon, IconName, Toast } from 'react-frontier';

interface UploadBoxProps{
	className?: string,
	type?: 'normal' | 'green' | 'red',
	text?: string,
	single?: boolean
	icon?: IconName,
	maxFileSize?: number,
	onFile: (file: File)=>void,
}

var UploadBox = (props: UploadBoxProps)=>{
	var idRef = useRef<HTMLInputElement>(null);

	var handleImage = (ev: React.ChangeEvent<HTMLInputElement>)=>{
		if(!ev.target.files || ev.target.files.length==0) return;
		if(ev.target.files.length>1 && props.single!==false) return Toast.error("Favor de solo seleccionar 1 archivo.");
		var file = ev.target.files[0];
		if(props.maxFileSize && file.size>props.maxFileSize) return Toast.error('La imagen no puede pesar mas de 2.5MB.');

		if(props.onFile) props.onFile(file);
	}

	var boxClick = ()=>{
		idRef.current?.click();
	}
	
	return <div className={classNames("tp uploadbox", props.type, props.className)} onClick={boxClick}>
		<input type="file" ref={idRef} accept="image/*,.pdf" onChange={handleImage} />
		<div className="contents">
			<Icon name={props.icon || 'file'} />
			<div className="text">{props.text || 'Da click para subir el archivo'}</div>
		</div>
	</div>
}

export default UploadBox;